import React from 'react';
import { Spinner } from 'react-bootstrap';

import EventSelector from '../../../components/EventSelector/Modal';
import EventSelectorButton from '../../../components/EventSelector/Button';
import UpdateButton from '../UpdateButton';

/**
 * Shared layout for Languages pages (Template and AiTemplate).
 * Renders header, loading state, content, and EventSelector.
 */
const LanguagesPageShell = ({ loading, updateHandler, children }) => (
  <div className="d-flex flex-column flex-grow-1">
    <div className="pageHeader">
      <h4>Languages</h4>
      <EventSelectorButton showFutureEvents />
      <UpdateButton serverErrorMessage label="Update Event" updateHandler={updateHandler} />
    </div>

    {loading && (
      <div className="flex-grow-1 d-flex justify-content-center align-items-center">
        <Spinner animation="border" variant="primary" />
      </div>
    )}

    {!loading && children}

    <EventSelector singleSelection showTemplate showFutureEvents />
  </div>
);

export default LanguagesPageShell;
